import React, { useCallback, useEffect, useState } from 'react'
import data from '../components/PregnancyRiskScreening/PregnancyRiskScreeningData.json';
import WelcomeScreenPCOS from '../components/PCOSRiskScreening/WelcomeScreen';
// import { ConsentScreen } from './HealthAssessmentJourney';
import GenericScreen from '../components/HealthAssessment/GenericScreen';
import ReviewSubmitScreen from '../components/HealthAssessment/ReviewSubmitScreen';
import ResultsScreen from '../components/HealthAssessment/ResultsScreen';
import ViewResults from '../components/HealthAssessment/ViewSummary';
import styles from './PregRiskScreening.module.css'
// import { computeScore } from '../utils/scoreUtils';
// import pregnancyData from '../mockdata/pregnancy_screening.json'; // your new JSON
import pregnancyData from '../components/PregnancyRiskScreening/PregnancyRiskScreeningData.json';
import PregnancyScreening from '../components/PregnancyRiskScreening/PregWelcomeScreen';
import ConsentScreenPCOS from '../components/PCOSRiskScreening/ConsentScreenPCOS';
import ConsentScreen from '../components/Reusablecomponents/Consentscreen/Consentscreen';
// import { ConsentScreen } from './CareNavigator';


const screens = {
    1: "start",
    2: "consent",
    3: "pregRiskScreen",
    4: "reviewSummary",
    5: "riskResult",
    6: "nextAction"
};

// scoreUtils_pregnancy.js  (or add alongside existing scoreUtils)

// ─── Build flat question list from your JSON ─────────────────────────────────
const ALL_QUESTIONS = pregnancyData.questions;

// ─── Resolve option by id OR label (same safety net as your existing util) ───
const resolveOption = (question, value) => {
    if (value == null || value === '') return null;
    const opts = question.options || [];
    return (
        opts.find((o) => o.id === value) ||
        opts.find((o) => o.label === value) ||
        opts.find((o) => String(o.label).toLowerCase() === String(value).toLowerCase()) ||
        null
    );
};

const scoreForValue = (question, value) => {
    // Sliders have no options — value IS the numeric score
    if (question.type === 'slider') {
        const num = Number(value);
        return isNaN(num) ? 0 : num;
    }
    return resolveOption(question, value)?.score ?? 0;
};

export const maxScoreForQ = (question) => {
    if (question.type === 'slider') return question.max ?? 10;
    return Math.max(0, ...(question.options || []).map((o) => o.score ?? 0));
};

// ─── Severity helpers (same as your existing util) ──────────────────────────
export const SCORE_RANGES = [
    { min: 0, max: 20, label: 'Low Risk', risk: 'low', color: '#059669' },
    { min: 21, max: 40, label: 'Mild Risk', risk: 'mild', color: '#16A34A' },
    { min: 41, max: 60, label: 'Moderate Risk', risk: 'moderate', color: '#D97706' },
    { min: 61, max: 80, label: 'High Risk', risk: 'high', color: '#DC2626' },
    { min: 81, max: 100, label: 'Severe Risk', risk: 'severe', color: '#7F1D1D' },
];
const rangeFromPct = (pct) =>
    SCORE_RANGES.find((r) => pct >= r.min && pct <= r.max) ?? SCORE_RANGES.at(-1);

// ─── RED FLAG question ids ───────────────────────────────────────────────────
// These are danger signs — if answered "yes", escalate regardless of total score
const RED_FLAG_IDS = new Set([
    'vaginal_bleeding',
    'severe_abdominal_pain',
    'severe_headache',
    'blurred_vision',
    'swelling_face_hands',
]);

// ────────────────────────────────────────────────────────────────────────────
// computeScore
//
// allAnswers shape (from your existing updateAnswer calls):
//   {
//     "pregnancy_confirmation": { "is_currently_pregnant": "yes", ... },
//     "medical_history":        { "high_blood_pressure": "yes", ... },
//     ...
//   }
//   key = question.group, value = { [question.id]: answeredValue }
// ────────────────────────────────────────────────────────────────────────────
// export const computeScore = (allAnswers) => {
//     if (!allAnswers || Object.keys(allAnswers).length === 0) return null;

//     // ── Your answers are stored as: allAnswers["Pregnancy Risk Screening"][q.id]
//     // ── But we look up as: allAnswers[q.group][q.id]
//     // ── Fix: pull the flat object out, then re-key by each question's group ────
//     const SCREENING_KEY = "Pregnancy Risk Screening";
//     const flat = allAnswers[SCREENING_KEY] ?? allAnswers;

//     // Remap: { [q.group]: { [q.id]: value } }
//     const grouped = {};
//     ALL_QUESTIONS.forEach((q) => {
//         if (flat[q.id] !== undefined) {
//             grouped[q.group] = grouped[q.group] || {};
//             grouped[q.group][q.id] = flat[q.id];
//         }
//     });

//     console.log("[computeScore] remapped grouped:", grouped);

//     // ── Now use `grouped` instead of `allAnswers` everywhere below ────────────
//     let raw = 0;
//     let maxPossible = 0;
//     const redFlags = [];

//     const SKIP_GROUPS = new Set(['pregnancy_confirmation', 'fertility_context']);

//     ALL_QUESTIONS.forEach((q) => {
//         if (SKIP_GROUPS.has(q.group)) return;

//         const groupAnswers = grouped[q.group] || {};  // ← grouped, not allAnswers
//         const value = groupAnswers[q.id];

//         if (RED_FLAG_IDS.has(q.id)) {
//             const resolved = resolveOption(q, value);
//             const fired =
//                 resolved?.id === 'yes' ||
//                 String(resolved?.label || '').toLowerCase() === 'yes';

//             const RED_FLAG_WEIGHT = 20;
//             raw += fired ? RED_FLAG_WEIGHT : 0;
//             maxPossible += RED_FLAG_WEIGHT;
//             if (fired) redFlags.push(q.label);
//             return;
//         }

//         const score = scoreForValue(q, value);
//         const max = maxScoreForQ(q);
//         raw += score;
//         maxPossible += max;

//         console.log(`q="${q.id}" value="${value}" → ${score}/${max}`);
//     });

//     const percent = maxPossible > 0 ? Math.round((raw / maxPossible) * 100) : 0;
//     const range = rangeFromPct(percent);

//     console.log(`TOTAL: ${raw}/${maxPossible} = ${percent}% → "${range.label}"`);

//     return {
//         raw,
//         max: maxPossible,
//         percent,
//         label: range.label,
//         color: range.color,
//         risk: range.risk,
//         ranges: SCORE_RANGES,
//         redFlags,
//         redFlagNote: redFlags.length > 0
//             ? `⚠️ ${redFlags.length} red flag${redFlags.length > 1 ? 's' : ''} detected — consult a doctor promptly.`
//             : null,
//     };
// };
export const computeScore = (allAnswers) => {
    if (!allAnswers || Object.keys(allAnswers).length === 0) return null;
    console.log(allAnswers, "this is allanswers")
    const SCREENING_KEY = "Pregnancy Risk Screening";
    const flat = allAnswers[SCREENING_KEY] ?? {};

    const SKIP_GROUPS = new Set(['pregnancy_confirmation', 'fertility_context']);
    const RED_FLAG_WEIGHT = 20;

    let raw = 0;
    let maxPossible = 0;
    const redFlags = [];

    ALL_QUESTIONS.forEach((q) => {
        if (SKIP_GROUPS.has(q.group)) return;

        const answer = flat[q.id];  // { value, score }

        if (RED_FLAG_IDS.has(q.id)) {
            const fired = answer?.value === 'yes';
            raw += fired ? RED_FLAG_WEIGHT : 0;
            maxPossible += RED_FLAG_WEIGHT;
            if (fired) redFlags.push(q.label);
            return;
        }

        const score = answer?.score ?? 0;
        const max = maxScoreForQ(q);
        raw += score;
        maxPossible += max;

        console.log(`q="${q.id}" value="${answer?.value}" score=${score}/${max}`);
    });

    const percent = maxPossible > 0 ? Math.round((raw / maxPossible) * 100) : 0;
    const range = rangeFromPct(percent);

    console.log(`TOTAL: ${raw}/${maxPossible} = ${percent}% → "${range.label}"`);

    return {
        raw,
        max: maxPossible,
        percent,
        label: range.label,
        color: range.color,
        risk: range.risk,
        ranges: SCORE_RANGES,
        redFlags,
        redFlagNote: redFlags.length > 0
            ? `⚠️ ${redFlags.length} red flag${redFlags.length > 1 ? 's' : ''} detected — consult a doctor promptly.`
            : null,
    };
};
const PregnancyRiskScreening = () => {
    const [screen, setScreen] = useState("start");
    const [allAnswers, setAllAnswers] = useState({});
    const [openLastQuestion, setOpenLastQuestion] = useState(false);
    const [targetStepIndex, setTargetStepIndex] = useState(null)
    const [assessmentType, setAssessmentType] = useState(null);
    const goTo = (s, options = {}) => {
        setOpenLastQuestion(!!options.openLastQuestion);
        setTargetStepIndex(options.targetStepIndex ?? null);
        setScreen(s);
        window.scrollTo(0, 0);
    };
    useEffect(() => {
        console.log(allAnswers, "these r allanswers")
    }, [allAnswers])

    const buildPcosSections = (screenConf) => {
        const groupMap = new Map();
        let idx = 0;
        (screenConf.questions || []).forEach((q) => {
            const key = q.group || q.id;
            if (!groupMap.has(key)) {
                groupMap.set(key, {
                    step: idx,   // ← numeric index, onEdit receives this
                    label: q.group
                        ? q.group.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
                        : q.label,
                });
                idx++;
            }
        });
        return Array.from(groupMap.values());
    };
    const screenEntries = Object.entries(screens);
    const screenConf = data;
    console.log(screenConf, "this is the screenconf")

    const handleGoNext = () => {
        const currentIndex = screenEntries.findIndex(([, value]) => value === screen);
        if (currentIndex < screenEntries.length - 1) {
            goTo(screenEntries[currentIndex + 1][1]);
        }
    };

    const handleGoBack = () => {
        const currentIndex = screenEntries.findIndex(([, value]) => value === screen);
        if (currentIndex > 0) {
            goTo(screenEntries[currentIndex - 1][1]);
        }
    };

    // const updateAnswer = useCallback((screenTitle, field, value,score) => {
    //     setAllAnswers((prev) => ({
    //         ...prev,
    //         [screenTitle]: { ...(prev[screenTitle] || {}), [field]: value,score }
    //     }));
    // }, []);
    const updateAnswer = useCallback((screenTitle, field, value, score) => {
        setAllAnswers((prev) => ({
            ...prev,
            [screenTitle]: {
                ...(prev[screenTitle] || {}),
                [field]: { value, score: score ?? 0 }  // ✅ { value, score } object
            }
        }));
    }, []);

    const makeChangeHandler = (screenTitle) => (field, value, score) => {
        console.log(score, "this is the score")
        updateAnswer(screenTitle, field, value, score);
    };
    const content = {
        "title": "Risk Screening Personalization",
        "description": "Use my answers to personalize my health risk screening.",
        "pageSubtitle": "Let's find or create your profile so we can personalize your risk screening.",
    }
    return (
        <div className={styles.wrapper}>
            <div className={styles.cardPC}>
                <div className={styles.card}>
                    {screen === "start" && (
                        <PregnancyScreening onNext={() => goTo("consent")} />
                    )}
                    {screen === "consent" && (
                        <div className={styles.consentLayout}>
                            <ConsentScreen
                                onNext={() => goTo('pcosRiskScreen')}
                                onBack={() => goTo('start')}
                                // showPageWrap={false}
                                // content={"Risk Screening Personalization"}
                                content={content}
                            />
                        </div>

                    )}

                    {screen === 'pcosRiskScreen' && (
                        <div className={styles.cardFixedLayout}>
                            <GenericScreen
                                initialStepIndex={targetStepIndex}
                                openLastQuestion={openLastQuestion}
                                screenConfig={screenConf}
                                data={allAnswers?.[screenConf.title] || {}}
                                onChange={makeChangeHandler(screenConf.title)}
                                onNext={() => goTo('review')}
                                onBack={() => goTo('consent')}
                            />
                        </div>
                    )}

                    {screen === 'review' && (
                        <ReviewSubmitScreen
                            allAnswers={allAnswers}
                            onEdit={(stepIdx) => goTo('pcosRiskScreen', { targetStepIndex: stepIdx })}
                            onSubmit={() => goTo('results')}
                            onBack={() => goTo('pcosRiskScreen', { openLastQuestion: true })}
                            customSections={buildPcosSections(screenConf)}
                            assessmentType={"PCOS Risk"}
                        />
                    )}
                    {screen === 'results' && (
                        <ResultsScreen
                            answers={allAnswers}
                            assessmentType={"PCOS Risk"}
                            goTo={() => goTo('viewSummary')}
                            scoreResult={computeScore(allAnswers)}
                            onBack={() => goTo('review')}
                        />
                    )}
                    {screen === 'viewSummary' && (
                        <ViewResults
                            answers={allAnswers}
                            assessmentType={assessmentType}
                            onBack={() => goTo('results')}

                        />
                    )}
                </div>
            </div>
        </div>
    )
}

export default PregnancyRiskScreening